import IconInfoCircle from '@fortuneo/ui-icons/pictograms/IconInfoCircle'
import React, { type FC } from 'react'

export const SimulatorResponseFailure: FC = () => (
  <div className="flex h-full flex-col items-center justify-center p-10">
    <IconInfoCircle className="mb-5" fontSize="large" />
    <p className="text-center">
      Les informations saisies ne permettent pas de réaliser la simulation de
      votre projet immobilier.
    </p>
  </div>
)
